import { render, staticRenderFns } from "./customFields.vue?vue&type=template&id=9b1e7e80"
import script from "./customFields.ts?vue&type=script&lang=js&external"
export * from "./customFields.ts?vue&type=script&lang=js&external"
import style0 from "./customFields.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports